import { Box, Button, Grid, LinearProgress } from '@material-ui/core';
import { createTheme, lighten, withStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { TransitionProps } from '@mui/material/transitions';
import axios from "axios";
import MaterialTable, { Localization } from '@material-table/core';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import 'whatwg-fetch';
import { API_URL, AUTHORITY, RE_LOGIN_MESSAGE, AUTHORITY_NO_LIST } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';


const theme = createTheme({
  /*
  palette: {
    secondary: {
      main: "rgba(33, 150, 243, 1) !important",
    },
  },
  */
  overrides: {
    MuiTableRow: {
      hover: {
        "&:hover": {
          backgroundColor: "rgba(33, 150, 243, 0.25) !important"
        }
      }
    }
  }
});

const localizationJapanese: Localization = {
  error: "エラー",
  body: {
    emptyDataSourceMessage: "表示するレコードがありません。",
    filterRow: {
      filterTooltip: "フィルター",
    },
  },
  header: {
    actions: "アクション",
  },
  grouping: {
    groupedBy: "グループ化:",
    placeholder: "ヘッダーをドラッグ ...",
  },
  pagination: {
    firstTooltip: "最初のページ",
    firstAriaLabel: "最初のページ",
    previousTooltip: "前のページ",
    previousAriaLabel: "前のページ",
    nextTooltip: "次のページ",
    nextAriaLabel: "次のページ",
    labelDisplayedRows: "{from}-{to} 全{count}件",
    labelRowsPerPage: "ページあたりの行数:",
    lastTooltip: "最後のページ",
    lastAriaLabel: "最後のページ",
    labelRowsSelect: "行",
  },
  toolbar: {
    nRowsSelected: "{0} 行選択",
  },
};

/* CSS */
const BorderLinearProgress = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#0000FF',
  },
})(LinearProgress);



/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/


// 画面表示
const Constructionlist: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  const history = useHistory();

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [resultOpen, setResultOpen] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const handleResultOpen = () => {
    setResultOpen(true);
  };
  const handleResultClose = () => {
    setResultOpen(false);
  };


  /*ダイアログ処理*/


  const label = { inputProps: { 'aria-label': 'Checkbox user' } };
  const [posts, setPosts] = useState<any[]>([])
  const [addUserFlg, setAddUserFlg] = useState(false);
  const [delItems, delCheckedItems] = useState<any[]>([])
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')




  const [totalUserCount, setTotalUserCount] = useState<string>('')

  useEffect(() => {
    if (jsonlist.user.authority_code === AUTHORITY_NO_LIST.USER.toString()) {
      history.push({ pathname: "/Constructionlist" });
    } else {
      openLoading()
      axios.post(API_URL.USER_LIST,
        {
          "company_id": jsonlist.user.company_id
        },
        { headers: { Authorization: jsonlist.token.IdToken } },

      )
        .then(res => {
          const persons = res.data.data;
          setPosts(persons)
        })
        .catch(error => {
          //let jsonObject = JSON.parse(error);
          console.log(error)
          // Http StatusCode 401なら権限エラーなので工事一覧へ飛ばす (DOKODEMO_R-99暫定対処)
          if (error.response.status === 401) {
            history.push({ pathname: "/Constructionlist" });
          } else {
            // ここでエラーになるのはログインができていない可能性が高いのでログイン画面に遷移する
            history.push({ pathname: "/login", state: { err: RE_LOGIN_MESSAGE, } });
          }
        })
        .finally(() => {
          closeLoading()
        })

      openLoading()
      axios.post(API_URL.COMPANY_GET,
        {
          "company_id": jsonlist.company.company_id
        },
        { headers: { Authorization: jsonlist.token.IdToken } },
      )
        .then(res => {
          const company = res.data.data;
          setTotalUserCount(company.total_user_count)
        })
        .catch(error => {
          console.log('ユーザー一覧画面 会社情報取得失敗')
          console.log(error)
        })
        .finally(() => {
          closeLoading()
        })
    }
  }, []);

  // ユーザー追加ボタンの活性/非活性変更処理
  useEffect(() => {
    // レンダリング制御
    if (posts?.length > 0 && totalUserCount !== '') {
      // 最大ユーザー数 > 利用ユーザー数 → true
      // 最大ユーザー数 < 利用ユーザー数 →false
      setAddUserFlg(posts?.length < parseInt(totalUserCount));
    }
  }, [totalUserCount, posts])
  /*配列データ*/
  const rows: any = [];
  posts.map((item) => {
    if (parseInt(item.authority_code) >= parseInt(jsonlist.user.authority_code)) {
      rows.push({ user_name: item.user_name, user_id: item.user_id, authority_code: AUTHORITY[item.authority_code], last_login_at: item.last_login_at, remarks: item.remarks })
    }
  })

  // 削除処理
  const clickSubmit = (e: any) => {
    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/

    //console.log(delItems)

    // POST処理　削除

    openLoading()
    axios.post(API_URL.USER_DELETE,
      {
        "company_id": jsonlist.user.company_id,
        "user_id": delItems
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const del = res.data.data;
        setSuccess(true);
        setLoading(false);
        console.log('削除成功')
        setResultMessage('削除に成功しました。')
        handleClose();
        handleResultOpen();
        // ユーザーデータ再読み込み
        axios.post(API_URL.USER_LIST,
          {
            "company_id": jsonlist.user.company_id
          },
          { headers: { Authorization: jsonlist.token.IdToken } },

        )
          .then(res => {
            const persons = res.data.data;
            setPosts(persons)
          })
          .catch(error => {
            //let jsonObject = JSON.parse(error);
            console.log(error)
          });
      })
      .catch(error => {
        setSuccess(true);
        setLoading(false);
        setResultMessage(error.response.data.errMessage)
        handleClose();
        handleResultOpen();
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }


  /*削除処理へ*/
  const del_date = (e: any) => {
    const del_list = []
    for (let i in e) {
      del_list.push(e[i].user_id)
    }
    console.log(del_list)
    delCheckedItems(del_list)
  }
  /*削除処理へ*/

  /*詳細画面へ*/
  const Linkto = (e: any) => {
    console.log(e)
    history.push({
      pathname: "/UserDetail", state:
      {
        id: e.user_id,
        comid: jsonlist.user.company_id,
        user_name: e.user_name,
        user_name_kana: e.user_name_kana,
        authority_code: e.authority_code,
        remarks: e.remarks
      }
    });
  }
  /*詳細画面へ*/





  return (
    <GenericTemplate title="ユーザーリスト">
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"このデータを削除しますか？"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >キャンセル</Button>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                {loading
                  ?
                  <Button
                    style={{ width: "100px" }}
                    variant="contained"
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                  :
                  <Button
                    style={{ color: "#fff", backgroundColor: "red", width: "100px" }}
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                }
                {loading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={resultOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleResultClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{resultMessage}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleResultClose}
                >OK</Button>
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>


      <Stack spacing={3} margin={2}></Stack>

      <div className="textBoxUser">
        <Stack spacing={3} margin={2}>
          <Grid container spacing={0}>
            <Grid item xs={12}>{jsonlist.company.company_name}</Grid>
          </Grid>
        </Stack>

        <Stack spacing={3} margin={2}>
          <Grid container spacing={0}>
            <Grid item xs={2}>利用ユーザー数</Grid>
            <Grid item xs={4}><TextField id="standard-basic" label="" variant="standard" value={rows?.length || ''} className="InsText2" />人</Grid>
            <Grid item xs={2}>最大ユーザー数</Grid>
            <Grid item xs={4}><TextField id="standard-basic" label="" variant="standard" value={totalUserCount} className="InsText2" />人</Grid>
          </Grid>
        </Stack>
      </div>

      <Stack spacing={3} margin={4}></Stack>
      <Grid container spacing={3}>
        <Grid item sm={11} xs={11}>
          <Button
            className="btnlink"
            color="primary"
            variant="contained"
            size="large"
            component={Link}
            to="/UserCreate"
            disabled={!addUserFlg}
          >
            ＋ ユーザー追加
          </Button>
          {!addUserFlg && (
            <span style={{ color: 'red', fontWeight: 600, padding: 3, fontSize: '1rem' }}>
              ※最大ユーザー数に達しています
            </span>
          )}
        </Grid>
        <Grid item xs={1}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              {jsonlist.user.authority_code !== AUTHORITY_NO_LIST.USER.toString() ?
                delItems.length > 0 ?
                  <Button
                    style={{ color: "#fff", backgroundColor: "red" }}
                    variant="contained"
                    onClick={handleClickOpen}
                  >
                    削除
                  </Button>
                  :
                  <Button
                    variant="contained"
                    onClick={handleClickOpen}
                    disabled={true}
                  >
                    削除
                  </Button>
                : <></>
              }
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Stack spacing={3} margin={1}></Stack>

      <ThemeProvider theme={theme}>
        <MaterialTable
          options={{
            search: true,
            draggable: true,
            filtering: false,
            selection: true,
            pageSize: 10,
            showSelectAllCheckbox: false,
            headerStyle: {
              backgroundColor: '#ececec',
              color: '#000',
              textAlign: "left",
              fontWeight: "600",
            },
          }}
          columns={[

            {
              title: 'ユーザー名',
              field: 'user_name',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: 'メールアドレス',
              field: 'user_id',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '権限',
              field: 'authority_code',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '最終ログイン日時',
              field: 'last_login_at',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '備考',
              field: 'remarks',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
          ]}
          data={rows}
          title="ユーザーリスト"
          onRowClick={(event, rowData,) => Linkto(rowData)}
          onSelectionChange={(rowDatas, rowData) => del_date(rowDatas)}
          localization={localizationJapanese}
        />
      </ThemeProvider>


    </GenericTemplate >
  );
};

export default Constructionlist;